import { ValidationError } from "@common/types";
import { ProjectTemplateLinksReadModel } from "@Projects/Domain/readmodels";

export class ProjectTemplateLinksManagerViewModel
{
    opened: boolean = false;

    initialized: boolean = false;
    updating: boolean = false;

    projectId: number | null = null;
    projectName: string | null = null;
    data: ProjectTemplateLinksReadModel | null = null;

    error: string | null = null;

    show(projectId: number, projectName: string)
    {
        this.projectId = projectId;
        this.projectName = projectName;

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.projectId = null;
        this.projectName = null;
    }

    setData(data: ProjectTemplateLinksReadModel)
    {
        this.updating = false;

        this.data = data;

        this.initialized = true;
    }

    resetData()
    {
        this.initialized = false;
        this.data = null;
    }

    displayValidationErrors(errors: ValidationError[])
    {
        this.updating = false;

        for (const error of errors)
        {
            if (error.ErrorCode == "DuplicatedNames")
            {
                this.error = error.Error;
            }
        }
    }
}